














import { Vue, Component, Prop } from 'vue-property-decorator'
import Category from '@/store/models/category'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import { Getter } from 'vuex-class'
import * as types from '@/store/content/types'

@Component({ components: { ChevronDown, ChevronUp } })
export default class TreeMenu extends Vue {
  @Prop({ default: [] }) category!: Category
  @Getter('bookTree', { namespace: 'content' }) bookTree!: types.BookTree

  private expand = false

  private handleClick () {
    if (this.category.children.length > 0) {
      this.expand = !this.expand
    }
    this.$router.push({ name: 'category', params: { category: this.category.id.toString() } }).catch(() => null) // Catch redundant nav error
  }

  private get isActive () {
    return this.$route.params.category === this.category.id.toString()
  }
}

